import Link from "gatsby-link";
import React from "react";

import { FieldArguments } from "components/FieldArguments";
import { FieldType } from "components/FieldType";
import { Breadcrumbs } from "components/Breadcrumbs";
import { CodeExample } from "components/CodeExample";

// https://stackoverflow.com/questions/15150168/title-case-in-javascript-for-diacritics-non-ascii
export function toTitleCase(str) {
  if (!str) return str;

  return str.replace(/[^\s]+/g, (word) =>
    word.replace(/^./, (first) => first.toUpperCase())
  );
}

const generateTypeExample = (name, fields) => {
  if (!fields || fields.length === 0) return null;

  const sampleFields = fields.slice(0, 5).map(f => `  ${f.name}`).join("\n");
  return `query {
  # Use this type in your queries
  someQuery {
${sampleFields}
  }
}`;
};

const Type = ({
  pathContext: { name, kind, description, fields, enumValues, possibleTypes },
}) => {
  const kindLabel = toTitleCase(kind.toLowerCase().replace(/_/g, " "));
  const breadcrumbItems = [
    { label: kindLabel + "s", path: null },
    { label: name, path: null }
  ];

  const exampleCode = generateTypeExample(name, fields);

  return (
    <div className="page">
      <section>
        <div className="section-text">
          <Breadcrumbs items={breadcrumbItems} />
          <div className="type-header">
            <span className="type-badge">{kindLabel}</span>
            <h1>{name}</h1>
          </div>
          {description && <p className="type-description">{description}</p>}
        </div>
        {exampleCode && (
          <div className="section-example on">
            <CodeExample
              title="Usage Example"
              code={exampleCode}
              language="graphql"
            />
          </div>
        )}
      </section>
      {fields && fields.length > 0 && (
        <section>
          <div className="section-text">
            <h2>Fields</h2>
            {fields.map((f) => (
              <div className="object-field" key={f.name} id={`field-${f.name}`}>
                <div className="field-header">
                  <code className="field-name">{f.name}</code>
                  <span className="field-type-label">
                    <FieldType field={f} />
                  </span>
                  {f.type && f.type.kind === "NON_NULL" && (
                    <span className="required-badge">required</span>
                  )}
                </div>
                <FieldArguments argument={f} />
                {f.isDeprecated && (
                  <div className="deprecated-warning">
                    <strong>DEPRECATED:</strong> {f.deprecationReason}
                  </div>
                )}
                {f.description && (
                  <p className="field-description">{f.description}</p>
                )}
              </div>
            ))}
          </div>
          <div className="section-example" />
        </section>
      )}
      {enumValues && enumValues.length > 0 && (
        <section>
          <div className="section-text">
            <h2>Values</h2>
            {enumValues.map((e) => (
              <div className="object-field">
                <div className="object-field-name">{e.name}</div>
                <p>{e.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}
      {possibleTypes && possibleTypes.length > 0 && (
        <section>
          <div className="section-text">
            <h2>Possible Types</h2>
            {possibleTypes.map((f) => (
              <div className="object-field" key={f.name}>
                <div className="object-field-name">
                  {f.name}&nbsp; (
                  {f.kind === "LIST" ? (
                    <span>
                      [
                      <Link
                        to={`/${f.ofType.kind.toLowerCase()}/${f.ofType.name}`}
                        className="object-field-type"
                      >
                        {f.ofType.name}
                      </Link>
                      ]
                    </span>
                  ) : (
                    <Link
                      to={`/${f.kind.toLowerCase()}/${f.name}`}
                      className="object-field-type"
                    >
                      {f.name}
                    </Link>
                  )}
                  )
                </div>
                <p>{f.description}</p>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default Type;



// WEBPACK FOOTER //
// ./src/templates/object.js